module.exports = {
  APPLICATION: "APPLICATION",
  PLUGIN_LOAD_TIMEOUT: 5000
};



// WEBPACK FOOTER //
// ./src/js/constants/PluginConstants.js